__turbopack_context__.v({
  "button": "BannerSliderSert-module-scss-module__W5-3eW__button",
  "content": "BannerSliderSert-module-scss-module__W5-3eW__content",
  "discount": "BannerSliderSert-module-scss-module__W5-3eW__discount",
  "img": "BannerSliderSert-module-scss-module__W5-3eW__img",
  "list": "BannerSliderSert-module-scss-module__W5-3eW__list",
  "listItem": "BannerSliderSert-module-scss-module__W5-3eW__listItem",
  "listTitle": "BannerSliderSert-module-scss-module__W5-3eW__listTitle",
  "price": "BannerSliderSert-module-scss-module__W5-3eW__price",
  "root": "BannerSliderSert-module-scss-module__W5-3eW__root",
  "slider": "BannerSliderSert-module-scss-module__W5-3eW__slider",
  "title": "BannerSliderSert-module-scss-module__W5-3eW__title",
  "titleCounter": "BannerSliderSert-module-scss-module__W5-3eW__titleCounter",
  "topText": "BannerSliderSert-module-scss-module__W5-3eW__topText",
  "topTextWrap": "BannerSliderSert-module-scss-module__W5-3eW__topTextWrap",
  "topTip": "BannerSliderSert-module-scss-module__W5-3eW__topTip",
});
